import axiosHelper from '@/utils/axiosHelper'

export default {
  // 获取Number流水编号
  getNumber: async function (numberCode) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Number.GetNumber', {
      numberCode: numberCode
    })
    if (rtnObj.error === '000000') {
      return rtnObj.data
    } else {
      return ''
    }
  }
}
